const getGlobalStyles = () => ({
  html: {
    height: "100%",
    width: "100%",
    overflow: "hidden",
  },

  body: {
    fontFamily: "Montserrat",
    height: "100%",
    width: "100%",
    margin: "0%",
    overflow: "hidden",
  },

  ":root": {
    "--color-hex": "#1E1E1E",

    "--text-primary": "#1e1e1e",
    "--text-secondary": "#5b6472",
    "--text-muted": "#7c8695",

    "--surface-page": "#f4f6fa",
    "--surface-card": "#ffffff",
    "--surface-subtle": "#f7f8fb",
    "--surface-disabled": "#eef0f4",

    "--border-subtle": "#e3e7ee",
    "--border-strong": "#c8d0dc",

    "--brand-primary": "#1e50c4",
    "--brand-accent": "#007bff",
    "--danger": "#da2e23",
    "--success": "#1b7f4b",

    "--radius-sm": "6px",
    "--radius-md": "10px",

    "--shadow-card":
      "0 1px 2px rgba(16, 24, 40, 0.06), 0 6px 16px rgba(16, 24, 40, 0.06)",

    "--xs-spacing": "0.25rem",
    "--s-spacing": "0.5rem",
    "--m-spacing": "0.75rem",
    "--l-spacing": "1rem",
    "--xl-spacing": "1.5rem",

    "--field-height": "2.625rem",
    "--background-default": "#e3e7ee",
  },

  ".appLayout": {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden",
  },

  ".appLayoutContent": {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
  },
});

export default getGlobalStyles;
